import React from 'react';
import VBox from '../../components/layout/VBox';
import Cabecalho from '../../components/tipografia/Cabecalho';
import Texto from '../../components/tipografia/Texto';
import Markdown from '../chat/Markdown';
import styles from './page.module.css';

const TermosUsoPage = () => {
    return (
        <VBox style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
            <Markdown className={styles.container} value={`        
# POLÍTICA DE PRIVACIDADE – TERACHAT

**Última atualização:** 18/12/2025

Esta Política de Privacidade descreve como a **Terachat** realiza o tratamento de dados pessoais no contexto da prestação de seus serviços, em conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018).

---

## 1. Papéis na LGPD

- **Cliente:** Controlador dos dados pessoais de seus usuários e clientes finais.
- **Terachat:** Operadora, tratando dados conforme instruções do Cliente.

---

## 2. Dados Pessoais Tratados

A Terachat pode tratar, conforme o uso da plataforma:
- Dados cadastrais do Cliente e de seus usuários;
- Dados de contatos finais (nomes, telefones, mensagens);
- Metadados de atendimento (datas, horários, status);
- Registros técnicos e logs de sistema (IP, eventos, autenticação).

---

## 3. Finalidade do Tratamento

Os dados pessoais são tratados para:
- Prestação dos serviços contratados;
- Operação dos canais de comunicação integrados;
- Geração de relatórios e métricas;
- Suporte técnico e operacional;
- Cumprimento de obrigações legais e regulatórias.

---

## 4. Compartilhamento de Dados

4.1. Os dados podem ser compartilhados com:
- Provedores de infraestrutura e tecnologia;
- Serviços e plataformas integradas (ex.: WhatsApp/Meta);
- Autoridades públicas, quando exigido por lei.

4.2. A Terachat não realiza a venda ou comercialização de dados pessoais.

---

## 5. Segurança da Informação

A Terachat adota medidas técnicas e organizacionais razoáveis para proteger os dados contra acesso não autorizado, perda, alteração ou uso indevido.

Nenhum sistema é completamente livre de riscos, mas são aplicadas boas práticas de mercado.

---

## 6. Retenção e Exclusão de Dados

6.1. Os dados são mantidos enquanto necessários para a execução do contrato ou cumprimento de obrigações legais.

6.2. Após o encerramento da relação contratual, os dados poderão ser excluídos ou anonimizados, salvo obrigação legal em contrário.

---

## 7. Direitos dos Titulares

O exercício dos direitos dos titulares de dados (acesso, correção, exclusão, portabilidade, etc.) deve ser solicitado ao Cliente, enquanto controlador.

A Terachat prestará apoio técnico ao Cliente, quando aplicável.

---

## 8. Alterações nesta Política

Esta Política pode ser atualizada periodicamente. A versão vigente estará sempre disponível na plataforma ou site da Terachat.

---

## 9. Contato

Em caso de dúvidas sobre esta Política ou sobre proteção de dados pessoais, entre em contato pelo e-mail:

**contato@terachat.com.br**
`} />
        </VBox>
    );
};

export default TermosUsoPage;
